import { Tabs } from './Tabs'
import { Tab } from './Tab'

Tabs.Tab = Tab

export { Tabs, Tab }
export default Tabs
